import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { IDetalheUsuario, IDetalheUsuarioCadastro, UsuarioService } from "../services/api/usuario/UsuarioService";
import { IDadosRetorno, IDadosLogin, AuthService, Ilogin } from "../services/autenticacao/AuthService";
import CookieService from "../services/autenticacao/CookieService";
import { useAppThemeContext } from "./ThemeContext";
import { useCookies } from "react-cookie";

interface IAuthContextData {
    logout: () => void;
    isAuthenticated: boolean;
    isCadastred: boolean;
    handleLogin: (dados: Ilogin) => Promise<string | void>;
    handleCadastrar: (dadosCadastro: IDetalheUsuarioCadastro) => Promise<any>;
    alterarThema: (nomeThema: string) => void;
}

const LOCAL_STORAGE_KEY__ACCESS_TOKEN = "@Auth:token";

const AuthContext = createContext({} as IAuthContextData);

interface IAuthProviderProps {
    children: React.ReactNode;
};

export const AuthProvider: React.FC<IAuthProviderProps> = ({ children }) => {
    let lgt = CookieService.get("Logout")
    const [acesssToken, setAcessToken] = useState<string>();
    const [deslogar, setDeslogar] = useState<boolean>(lgt !== "True");
    const [acessCadastro, setAcessCadastro] = useState<boolean>();
    const { toggleTheme, themeName } = useAppThemeContext();
    const [sendLogin, setSendLogin] = useState(true);
    const [cookies, setCookie, removeCookie] = useCookies();

    useEffect(() => {
        const token = CookieService.get("access_token"); // localStorage.getItem(LOCAL_STORAGE_KEY__ACCESS_TOKEN);         
        carregarToken(token);           
    }, [acesssToken]);

    const carregarToken = (token: string) => {        
        setAcessToken(token);
    }
    const handleLogin = useCallback(async (dadosLogin: Ilogin) => {
        // const result = await AuthService.login(dados);
        // if (result.status !== 1 || result.statusHTTP !== 200 || !result.processado) {
        //     return result.mensagem;
        // }
        // const dadosLogin: Ilogin = result.dado;
      
        handleLoginSuccess(dadosLogin, dadosLogin.lembrarme);
        setAcessToken(dadosLogin.chaveSessao);
        //window.location.reload();

    }, []);

    const handleLoginSuccess = (resultado: Ilogin, lembrarme: boolean) => {
        let options = {}

        if (!lembrarme) {
            options = { path: "/" };
        }
        else {
            let resDate = new Date(resultado.dtExpiracao);
            resDate.setTime(resDate.getTime() + (resDate.getTime() * 1000));
            options = { path: "/", expires: resDate };
        }
        
        setCookie("Logout", "False", {});
        setCookie("access_token", resultado.chaveSessao, options);
        setCookie("access_user", JSON.stringify(resultado), options);
        setCookie("access_thema", resultado.codTema.toString(), {});        
        setCookie("dados_Incompletos", resultado.dados_Incompletos, options);
        setCookie("imagem_Perfil", resultado.imagem_Perfil, options);

        return true;
    }

    const handleLogout = useCallback(() => {
        setDeslogar(true);
        setCookie("Logout", "True", {});
        removeCookie("access_user",{});
        removeCookie("access_thema",{});
        removeCookie("imagem_Perfil",{});        
        setAcessToken(undefined);
        localStorage.removeItem("@codigoLiga");
        removeCookie("access_token", {path:'/'});       
        localStorage.removeItem("@codigoFranquia");
        localStorage.removeItem("@codigoTemp");
        localStorage.removeItem("@codigoUsuFranquia");

    }, []);

    const handleAlteraThema = useCallback(async (nomeThema: string) => {
        removeCookie("access_thema");        
        const idThema = nomeThema === "dark" ? 1 : 2;
        UsuarioService.updateThemaById(idThema);        
        setCookie("access_thema", idThema.toString(), {});

    }, []);


    const handleCadastrar = useCallback(async (dadosCadastro: IDetalheUsuarioCadastro) => {

        const result = await AuthService.cadastrar(dadosCadastro);
        if (!result.processado) {
            setAcessCadastro(false);
        }
        setAcessCadastro(true);
        return result;

    }, []);

    const isAuthenticated = useMemo(() => {       
        let auth = acesssToken !== undefined ? true : false;
        setDeslogar(auth);
        return auth;
    }, [acesssToken]);

    const isCadastred = useMemo(() => !!acessCadastro, [acessCadastro])

    return (
        <AuthContext.Provider value={{
            isAuthenticated,
            isCadastred,
            handleLogin,
            logout: handleLogout,
            handleCadastrar,
            alterarThema: handleAlteraThema
        }}>
            {children}
        </AuthContext.Provider>

    );
};

export const useAuthContext = () => useContext(AuthContext);